import React from 'react';
import PropTypes from 'prop-types';

import { Divider, Alert } from 'antd';
import { Form as FormikForm, FormItem } from 'formik-antd';
import { ErrorMessage } from 'formik';
import { Fieldset } from 'components/form';

import { SingleFileUpload } from 'components/form/upload';
import { getUrlFromEvent } from 'utils/form';

import { DB_PREFIX } from './constants';
import StagePropTypes from './prop-types';

const tooltipText = `
To upload documents you can either use Word Documents, PDF's, JPEG's, PNG's or take images of the documents with your phone and upload.
These images are used for proof of ID.
`;

const generalHelp = `Upload photo of either a driving licence, passports or EU ID card.`;

const getFile = (path, values) => {
  return values[path] ? values[path] : null;
};

const Form = ({ isSubmitting, values, setFieldValue, uploadTo, children }) => {
  const fields = [
    {
      name: 'drivingLicenseURL',
      field: `${DB_PREFIX}.drivingLicenseURL`,
      file: getFile('drivingLicenseURL', values[DB_PREFIX]),
      label: 'Driving License',
    },
    {
      name: 'passportURL',
      field: `${DB_PREFIX}.passportURL`,
      file: getFile('passportURL', values[DB_PREFIX]),
      label: 'Passport',
    },
    {
      name: 'euIDCardURL',
      field: `${DB_PREFIX}.euIDCardURL`,
      file: getFile('euIDCardURL', values[DB_PREFIX]),
      label: 'EU ID Card',
    },
  ];

  return (
    <FormikForm layout="vertical">
      <Alert
        message={generalHelp}
        description={tooltipText}
        type="info"
        showIcon
      />
      <ErrorMessage name={DB_PREFIX}>
        {(msg) => (
          <>
            <Alert message={msg} type="error" showIcon />
            <Divider />
          </>
        )}
      </ErrorMessage>
      <Fieldset>
        {fields.map(({ label, field, file }) => {
          return (
            <FormItem key={field} name={field} label="">
              <SingleFileUpload
                className="ant-upload ant-upload-drag"
                title={label}
                subTitle="Click in this area to upload"
                file={file}
                uploadTo={uploadTo}
                multiple={false}
                showUploadList
                disabled={file != null || isSubmitting}
                onClear={() => {
                  setFieldValue(field, null);
                }}
                onChange={(e) => {
                  setFieldValue(field, getUrlFromEvent(e));
                }}
              />
            </FormItem>
          );
        })}
      </Fieldset>

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
  uploadTo: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  values: StagePropTypes.isRequired,
};

Form.defaultProps = {
  children: null,
  isSubmitting: false,
};

export default Form;
